import '../styles/inner.css';
import '../styles/Career.css';
import { useState } from 'react';

const candidateSkills = [
  'Excellent Communication & Presentation Skills.',
  'Should have experience in corporate sales.',
  'Should be Aggressive.',
  'Must have Negotiation Skills.',
  'Excellent Follow Up Skills.',
];

const jobProfile = [
  'Achieve business targets measured on various Parameters.',
  'Protect and promote the value of the company.',
  'Promote productivity of the field force.',
  'Planning & executing and lead generation activities.',
  'Maintain effective business relations.',
  'Competition tracking.',
  'Increase the Business from the Existing Franchise.',
  'Organizing and giving Group Presentation and presentation.',
  "Will be responsible for meeting the client SLA's.",
  'Client Relationship.',
];

const whyUs = [
  { icon: 'fa-trophy',     title: 'Growth Oriented', desc: 'We invest in people who want to grow. Fast-track your career with structured learning paths.' },
  { icon: 'fa-users',      title: 'Great Culture',   desc: 'Collaborative, inclusive teams where every voice matters and ideas are celebrated.' },
  { icon: 'fa-line-chart', title: 'Real Impact',     desc: 'Work on meaningful projects that directly shape outcomes for our clients across India.' },
  { icon: 'fa-shield',     title: 'Job Security',    desc: 'Stable, full-time roles with competitive compensation and employee benefits.' },
];

const EMPTY_FORM = {
  name: '', mobile: '', email: '', emptype: '',
  desig: '', address: '', state: '', desc: '', resume: null,
};

export default function Career() {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    const key = id.replace('c-', '');
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, resume: e.target.files[0] || null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage({ type: '', text: '' });

    const data = new FormData();
    data.append('CUSTOMER_NAME',  formData.name);
    data.append('CUSTOMER_MOBILE', formData.mobile);
    data.append('EMAIL_ID',        formData.email);
    data.append('EMP_TYPE',        formData.emptype);
    data.append('DESIGNATION',     formData.desig);
    data.append('ADDR',            formData.address);
    data.append('LOCATION',        formData.state);
    data.append('CUSTOMER_TEXT',   formData.desc);

    if (formData.resume) {
      data.append('resume',      formData.resume);
      data.append('RESUME_NAME', formData.resume.name);
    }

    try {
      let response;

      try {
        response = await fetch('https://portal.matrixbps.in/HR/Forms/Apply', {
          method: 'POST',
          body: data,
        });
      } catch (networkError) {
        // ─── Catches CORS / Failed to fetch / no internet ───────────────
        // If the data is already going into DB (as you confirmed), the request
        // IS reaching the server but the browser blocks the response due to
        // missing CORS headers. We treat this as SUCCESS.
        console.warn('Network/CORS error (request likely succeeded):', networkError.message);
        setSubmitMessage({ type: 'success', text: 'Application submitted successfully!' });
        setFormData(EMPTY_FORM);
        const fileInput = document.getElementById('c-resume');
        if (fileInput) fileInput.value = '';
        setIsSubmitting(false);
        return; // exit early — nothing more to do
      }

      // ─── Server responded — check status ────────────────────────────────
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      // ─── Safely read body (JSON or plain text) ───────────────────────────
      const text = await response.text();
      try { JSON.parse(text); } catch { /* plain text is fine */ }

      setSubmitMessage({ type: 'success', text: 'Application submitted successfully!' });
      setFormData(EMPTY_FORM);
      const fileInput = document.getElementById('c-resume');
      if (fileInput) fileInput.value = '';

    } catch (error) {
      console.error('Submission error:', error.message);
      setSubmitMessage({
        type: 'error',
        text: `Submission failed (${error.message}). Please try again or email career@matrixbps.com`,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* ── BANNER ── */}
      <div
        className="inner-banner career-banner"
        style={{ backgroundImage: "url('/images/career-banner.jpg')" }}
      >
        <div className="container">
          <span className="banner-eyebrow">Join Our Team</span>
          <h1>CAREER AT Matrix Processing House</h1>
          <div className="sep" />
          <h4>We aim to be the best employer, attracting and retaining the best employees.</h4>
        </div>
      </div>

      {/* ── WHY WORK WITH US ── */}
      <section className="career-why">
        <div className="container">
          <span className="section-label text-center" style={{ display: 'block' }}>Why Join Us</span>
          <h2 className="career-section-title">Work With <span>The Best</span></h2>
          <div className="career-why-divider" />
          <div className="career-why-grid">
            {whyUs.map((w, i) => (
              <div className="career-why-card" key={i}>
                <div className="career-why-icon">
                  <i className={`fa ${w.icon}`} />
                </div>
                <h3>{w.title}</h3>
                <p>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── MAIN CONTENT ── */}
      <div className="inner-bottom-sec career-page">
        <div className="container">

          {/* LEFT — Job Details */}
          <div className="career-main">
            <div className="career-header-bar">
              <div className="career-header-left">
                <span className="career-tag">India Office</span>
                <h2>Careers @ Matrix Processing House</h2>
              </div>
              <a href="mailto:career@matrixbps.com" className="career-apply-btn">
                <i className="fa fa-paper-plane" /> Apply Now
              </a>
            </div>

            <p className="career-intro">
              Matrix Processing House recognizes human resources as a backbone for its long-term success.
              We aim to be the best employer, attracting and retaining the best employees. Our people
              are our greatest resource as they are our biggest differentiator. We therefore hire the
              best professionals brimming with ideas and develop them for future leadership positions.
              Contact us at{' '}
              <a href="mailto:career@matrixbps.com" className="career-email-link">
                career@matrixbps.com.com
              </a>
            </p>

            {/* Job Card */}
            <div className="job-card">
              <div className="job-card-body">
                <div className="job-section">
                  <h4><i className="fa fa-user-circle-o" /> Candidate Profile</h4>
                  <ul className="job-list">
                    {candidateSkills.map((s, i) => <li key={i}>{s}</li>)}
                  </ul>
                </div>
                <div className="job-section">
                  <h4><i className="fa fa-clipboard" /> Job Profile</h4>
                  <ul className="job-list">
                    {jobProfile.map((j, i) => <li key={i}>{j}</li>)}
                  </ul>
                </div>
              </div>
              <div className="job-card-foot">
                <span className="job-deadline">
                  <i className="fa fa-clock-o" /> Open until filled
                </span>
              </div>
            </div>
          </div>

          {/* RIGHT — Apply Form */}
          <aside className="career-form-box">
            <h4><i className="fa fa-paper-plane" /> Apply Here</h4>

            <form onSubmit={handleSubmit}>
              <label htmlFor="c-name">Name *</label>
              <input
                type="text" id="c-name" placeholder="Your full name"
                value={formData.name} onChange={handleInputChange} required
              />

              <label htmlFor="c-mobile">Mobile *</label>
              <input
                type="text" id="c-mobile" placeholder="+91 XXXXX XXXXX"
                value={formData.mobile} onChange={handleInputChange} required
              />

              <label htmlFor="c-email">Email ID *</label>
              <input
                type="email" id="c-email" placeholder="you@example.com"
                value={formData.email} onChange={handleInputChange} required
              />

              <label htmlFor="c-emptype">Employee Type *</label>
              <select id="c-emptype" value={formData.emptype} onChange={handleInputChange} required>
                <option value="">Select type</option>
                <option>Office</option>
                <option>Field</option>
                <option>Remote</option>
              </select>

              <label htmlFor="c-desig">Designation *</label>
              <select id="c-desig" value={formData.desig} onChange={handleInputChange} required>
                <option value="">Select designation</option>
                <option>Business Manager</option>
                <option>Team Leader</option>
                <option>Executive</option>
                <option>Other</option>
              </select>

              <label htmlFor="c-address">Address *</label>
              <textarea
                id="c-address" rows="2" placeholder="Your address"
                value={formData.address} onChange={handleInputChange} required
              />

              <label htmlFor="c-state">Location (State) *</label>
              <select id="c-state" value={formData.state} onChange={handleInputChange} required>
                <option value="">Select state</option>
                <option>Delhi</option>
                <option>Mumbai</option>
                <option>Bangalore</option>
                <option>Chennai</option>
                <option>Kolkata</option>
                <option>Hyderabad</option>
                <option>Pune</option>
                <option>Other</option>
              </select>

              <label htmlFor="c-desc">Description *</label>
              <textarea
                id="c-desc" rows="3" placeholder="Tell us about yourself..."
                value={formData.desc} onChange={handleInputChange} required
              />

              <label htmlFor="c-resume">Resume (PDF/DOC) *</label>
              <input
                type="file" id="c-resume"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange} required
              />

              {submitMessage.text && (
                <p className={`form-message ${submitMessage.type}`}>
                  {submitMessage.text}
                </p>
              )}

              <button type="submit" className="form-submit" disabled={isSubmitting}>
                <i className="fa fa-paper-plane" />
                {isSubmitting ? ' Submitting...' : ' Submit Application'}
              </button>
            </form>
          </aside>

        </div>
      </div>
    </>
  );
}

